import React, { useState } from 'react'
import { Button, Form, Spinner } from 'react-bootstrap'

function CharityForm({ mode, charity, loading = false, onSubmit, onCancel }) {
  const isEdit = mode === 'edit'
  const [url, setUrl] = useState(isEdit ? charity.data.url : '')
  const [name, setName] = useState(isEdit ? charity.data.name : '')
  const [description, setDescription] = useState(isEdit ? charity.data.description : '')
  const [logoUrl, setLogoUrl] = useState(isEdit ? charity.data.logoUrl : '')
  const [category, setCategory] = useState(isEdit ? charity.data.category : '')
  const [active, setActive] = useState(isEdit ? charity.active : true)
  const [submitError, setSubmitError] = useState(null)

  async function handleSubmit(e) {
    e.preventDefault()
    setSubmitError(null)
    try {
      if (isEdit) {
        await onSubmit({ id: charity.id, active, data: { name, url, description, logoUrl, category } })
      } else {
        await onSubmit(url)
      }
    } catch (err) {
      setSubmitError(err.message)
    }
  }

  return (
    <Form onSubmit={handleSubmit} aria-label={isEdit ? 'Edit charity' : 'Add charity'}>
      {submitError && <p className="text-danger mb-3">{submitError}</p>}

      <Form.Group className="mb-3" controlId="charityUrl">
        <Form.Label>Website URL</Form.Label>
        <Form.Control
          type="url"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          required
          placeholder="https://example.org"
          disabled={loading}
        />
        {!isEdit && (
          <Form.Text className="text-muted">
            The AI agent will automatically fill in the charity details.
          </Form.Text>
        )}
      </Form.Group>

      {isEdit && (
        <>
          <Form.Group className="mb-3" controlId="charityName">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              disabled={loading}
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="charityDescription">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              disabled={loading}
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="charityLogoUrl">
            <Form.Label>Logo URL</Form.Label>
            <Form.Control
              type="url"
              value={logoUrl}
              onChange={(e) => setLogoUrl(e.target.value)}
              disabled={loading}
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="charityCategory">
            <Form.Label>Category</Form.Label>
            <Form.Control
              type="text"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              disabled={loading}
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="charityActive">
            <Form.Check
              type="checkbox"
              label="Active"
              checked={active}
              onChange={(e) => setActive(e.target.checked)}
              disabled={loading}
            />
          </Form.Group>
        </>
      )}

      <div className="d-flex gap-2">
        <Button type="submit" variant="primary" disabled={loading}>
          {loading ? (
            <>
              <Spinner size="sm" animation="border" aria-hidden="true" className="me-2" />
              {isEdit ? 'Saving…' : 'Adding…'}
            </>
          ) : isEdit ? (
            'Save Changes'
          ) : (
            'Add Charity'
          )}
        </Button>
        <Button variant="outline-secondary" onClick={onCancel} disabled={loading}>
          Cancel
        </Button>
      </div>
    </Form>
  )
}

export default CharityForm
